'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@sola/ark-core/molecules/radio-group/radio-group.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { useDonate } from '../donate-context.tsx';
import { DonateActionEnum, DonateFrequency } from '../donate.types.ts';
import { useDonateActions } from '../hooks/use-donate-actions.tsx';
export interface DonateFrequencySelectorProps {
  className?: string;
  alt?: boolean;
}
export const DonateFrequencySelector: React.FC<DonateFrequencySelectorProps> = t0 => {
  const $ = _c(19);
  const {
    className,
    alt
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["donations"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    state,
    config,
    dispatch
  } = useDonate();
  const {
    handleFrequencyChange
  } = useDonateActions();
  let t2;
  if ($[1] !== config.enabledFrequencies || $[2] !== t) {
    let t3;
    if ($[4] !== t) {
      t3 = frequency => ({
        value: frequency.toString(),
        text: `${t("donations:frequency", {
          context: frequency
        })}`,
        disabled: false
      });
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = config.enabledFrequencies.map(t3);
    $[1] = config.enabledFrequencies;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const frequencyItems = t2;
  if (!config.defaultFrequency || frequencyItems.length <= 1) {
    return null;
  }
  const t3 = `DonateFrequencySelector ${className || ""}`;
  const t4 = alt ? "flex-1" : "flex w-full justify-center items-center";
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = cn(t3, t4);
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== alt || $[10] !== dispatch || $[11] !== frequencyItems || $[12] !== handleFrequencyChange || $[13] !== state.donateFrequency || $[14] !== t) {
    t6 = alt ? <Select name="donateFrequencyDropdown" items={frequencyItems} value={state.donateFrequency} label={t("donations:frequency")} aria-label={t("donations:frequency")} onChange={e => {
      dispatch({
        type: DonateActionEnum.SET_FREQUENCY,
        payload: e.target.value as DonateFrequency
      });
      dispatch({
        type: DonateActionEnum.SET_OTHER_SELECTED,
        payload: true
      });
    }} /> : <RadioGroup key={`${state.donateFrequency}-frequency`} aria-label={t("donations:donateFrequency")} name="donateFrequency" items={frequencyItems} orientation="horizontal" onChange={e_0 => handleFrequencyChange(e_0.target.value as DonateFrequency)} value={state.donateFrequency} />;
    $[9] = alt;
    $[10] = dispatch;
    $[11] = frequencyItems;
    $[12] = handleFrequencyChange;
    $[13] = state.donateFrequency;
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};